


















import Vue from 'vue'
import { TRANSFER_ADDRESS_WEB_REPORT } from '@/store/action-types'

interface ComponentData {
  loading: boolean
}

export default Vue.extend({
  name: 'WebReportTransferDialog',

  props: {
    show: {
      type: Boolean,
      default: false
    },
    addressId: Number
  },

  data (): ComponentData {
    return {
      loading: false
    }
  },

  methods: {
    onCloseButtonClick (): void {
      this.$emit('close')
    },

    onNoButtonClick (): void {
      this.$emit('close')
    },

    onYesButtonClick (): void {
      this.transferWebReportData()
    },

    async transferWebReportData (): Promise<void> {
      try {
        this.loading = true
        const response: any = await this.$store.dispatch(TRANSFER_ADDRESS_WEB_REPORT, this.addressId)
        this.loading = false
        if(response.IsError) {
          this.$emit('error')
        } else {
          this.$emit('saved')
        }
      } catch (e) {
        this.loading = false
        this.$emit('error')
      }
    },
  },

  mounted (): void {
    setTimeout(() => {
      const yesBtn: any = this.$refs['yesBtn']
      if (yesBtn) {
        yesBtn.$el.focus()
      }
    }, 100)
  }
})
